import React from 'react';
import PropTypes from 'prop-types';
import { logo } from 'assets/img';
import { Typography, Icon, Button } from 'components/alf-design';
import { Row, Col } from 'components/alf-design/Grid';
import { useResponsive } from 'utils';
import { LegacyColors } from 'constants';
import './AppBarPayment.css';

const styles = {
  profileImg: {
    height: 30,
    width: 30,
    borderRadius: 22,
    verticalAlign: 'middle',
    cursor: 'pointer',
    color: LegacyColors.primary,
  },
};
const AppBarPayment = ({
  onLogin,
  onCreateAccount,
  onSideBar,
  onLogo,
  breakpoint = 'lg',
}) => {
  const { screenIsUp, screenIsDown } = useResponsive();
  return (
    <>
      <header className="alf-app-bar-p" role="banner">
        <nav>
          <div className="left">
            {screenIsDown(breakpoint) && (
              <Button
                ariaLabel="Menu"
                type="icon"
                style={{ margin: '0px 26px' }}
                id="Menu-Icon"
                onClick={onSideBar}
                icon={
                  <Icon
                    name="menu"
                    fontSize={24}
                    color="#6647DC"
                    style={{ margin: '4px' }}
                  />
                }
              />
            )}
            <Button
              id="slide-logo"
              data-testid="slide-logo"
              ariaLabel="Slide Insurance dashboard"
              type="icon"
              onClick={onLogo}
              className="bg-transparent border-0 p-0"
              icon={<img src={logo} alt="mySlide dashboard" className="logo" />}
            />
          </div>
          {screenIsUp(breakpoint) && (
            <Row className="right">
              <Col className="creteAccount">
                <Typography
                  id="create-account"
                  type="linkButton"
                  component="button"
                  onClick={onCreateAccount}
                  withTab
                >
                  Create Account
                </Typography>
              </Col>
              <Col className="login" style={styles.columns}>
                <Button
                  id="app-bar-login"
                  ariaLabel="login button"
                  type="primary"
                  component="button"
                  onClick={onLogin}
                  withTab
                >
                  Log In
                </Button>
              </Col>
            </Row>
          )}
        </nav>
        <Row className="titleBox">
          <Typography className="title">Make a One-Time Payment</Typography>
        </Row>
      </header>
    </>
  );
};

AppBarPayment.propTypes = {
  onLogin: PropTypes.func.isRequired,
  onCreateAccount: PropTypes.func.isRequired,
  onSideBar: PropTypes.func.isRequired,
  onLogo: PropTypes.func,
};

export default AppBarPayment;
